import {Injectable} from '@angular/core';
import { NgbDateNativeAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
    providedIn: 'root'
})
export class NativeDateAdapter extends NgbDateNativeAdapter {

    protected date:Date;

    protected _fromNativeDate(date: Date): NgbDateStruct {
        this.date = date;
        return {year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate()};
    }

    protected _toNativeDate(date: NgbDateStruct): Date {
        this.date.setDate(date.day);
        this.date.setMonth(date.month - 1);
        this.date.setFullYear(date.year);
        return this.date;
    }
}
